import PreferencesBaseController from "controllers/preferences_base_controller"
export default class extends PreferencesBaseController {
  static targets = ["button"]

  _updateUiElement(newValue) {
    if (this._getCurrentValue() !== newValue) {
      this.buttonTarget.click()
    }
  }

  _getCurrentValue() {
    return this.element.classList.contains("-collapsed")
  }
}
